import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import FiltrosReporteHistoriaEntity from 'src/app/classes/FiltrosReporteHistoriaEntity';
import { LoginEntity } from 'src/app/interfaces/login';
import { ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { ServicioImpresionTtaService } from 'src/app/services/servicio-impresion-tta.service';

@Component({
  selector: 'app-reporte-historia',
  templateUrl: './reporte-historia.component.html',
  styleUrls: ['./reporte-historia.component.css']
})
export class ReporteHistoriaComponent implements OnInit {

  showPDF: boolean = false;
  showHTML: boolean = false;
  loading: boolean = false;
  errorPermisos: boolean = false;

  login: LoginEntity;

  pdf: any;
  html: string;
  htmlBase: string;
  filtros: FiltrosReporteHistoriaEntity;

  constructor(private activatedRoute: ActivatedRoute,
    private impresionTTAService: ServicioImpresionTtaService,
    private servicioFormato: ServicioFormatoAsistencialService) {
    this.filtros = new FiltrosReporteHistoriaEntity();

    this.activatedRoute.params.subscribe(params => {
      this.filtros.codigBaseDatos = params['codigoBaseDatos'];
      this.filtros.sede = Number(params['uncoSede']);
      this.filtros.user = Number(params['uncoLogin']);
      this.filtros.tta = Number(params['tta']);
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.filtros.diligenciados = params['dlgncds'] && params['dlgncds'] === 'true';
      this.filtros.evoluciones = params['evlcns'] && params['evlcns'] === 'true';
      this.filtros.notas = params['nts'] && params['nts'] === 'true';
      this.filtros.solicitudServicios = params['srvcs'] && params['srvcs'] === 'true';
      this.filtros.firmaProfesional = params['frmaPrfsnl'] && params['frmaPrfsnl'] === 'true';
      this.filtros.firmaAfiliado = params['frmaAfldo'] && params['frmaAfldo'] === 'true';
    });
  }

  ngOnInit() {
    this.getUsuario();
  }

  async getUsuario() {
    try {
      this.loading = true;
      const request = await this.servicioFormato.getInformacionLogin(this.filtros.codigBaseDatos, this.filtros.user);
      if (request != null) {
        request.subscribe((login: LoginEntity) => {
          this.login = login;
          this.filtros.permisos = login.activaImpresion;
          this.onGenerate();
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          console.error('Error ReporteHistoria.getUsuario()', err);
        });
      }
    } catch (e) {
      console.error('Catch ReporteHistoria.getUsuario()', e);
    }
  }

  async onGenerate() {
    if (this.login.activaImpresion == 0) {
      this.errorPermisos = true;
      this.loading = false;
    } else {
      this.errorPermisos = false;
      this.showHTML = false;
      this.showPDF = false;
      this.loading = true;

      const request = await this.impresionTTAService.getReportHistory(this.filtros);
      if (request) {
        request.subscribe((data: any) => {
          if (this.filtros.isPDF()) {
            this.setPDF(data);
          } else {
            const parsed = JSON.parse(data);

            // this.htmlBase = data;
            // this.html = 'data:text/html;chartset=utf-8,' + escape(data);
            this.htmlBase = parsed.info;
            this.html =
              'data:text/html;charset=utf-8,' +
              encodeURIComponent(parsed.info);

            this.showHTML = true;
            this.loading = false;
          }
          if (this.login.activaImpresion == 1) {
            setTimeout(() => {
              this.onPrepareControlImpresion();
            }, 200);
          }
        }, (err: HttpErrorResponse) => {
          console.error('Error Response Generate Reporte Historia: ', err);
          this.loading = false;
        })
      }
    }

  }

  setPDF(data: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {

      this.pdf = reader.result;
      this.showPDF = true;
      this.loading = false;
    });

    reader.readAsDataURL(data);
  }

  onImprimir() {
    let popupWin: any;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
        </head>
        <body onload="window.print();window.close()">
        ${this.htmlBase}
        </body>
      </html>`
    );

    popupWin.document.close();
  }

  // Auxiliares

  isError(): boolean {
    return this.errorPermisos;
  }

  onPrepareControlImpresion() {
    window.addEventListener('keydown', (event: any) => {
      if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
        event.preventDefault();
        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        } else {
          event.stopPropagation();
        }
        return;
      }
    });

    window.addEventListener('keyup', (event: any) => {
      if (event.keyCode === 44) {
        this.copyToClipboard();
      }
    });

    window.addEventListener('contextmenu', (event: any) => {
      event.preventDefault();
    });

  }

  copyToClipboard() {
    const aux = document.createElement('input');
    aux.setAttribute('value', 'Impresiones de pantalla deshabilitadas !');
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
    alert('Impresiones de pantalla deshabilitadas !');
  }

}
